import { initializeRum } from './observability/rum';
import React from 'react';
import { createRoot } from 'react-dom/client';
import '@/instrument';
import App from './App';
import './index.css';
import { LanguageProvider } from './core/i18n/i18n';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
void initializeRum().finally(() =>
  root.render(
    <React.StrictMode>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </React.StrictMode>,
  ),
);
